import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';

@Component({
    selector: 'data-field-view-custom-pre-set-options',
    templateUrl: './custom-pre-set-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewCustomPreSetOptionsComponent extends FiDataFieldViewBase implements OnInit {
    displayValue: string;

    ngOnInit() {
        this.displayValue = this.dataField.PreSetValues.map((option) => option.Name).join(', ');
    }

    get isNotEmpty() {
        return !!this.displayValue;
    }
}
